import { ArticlePreviewResponse, ContentResponse, PublicContentResponse } from "@authory-packages/core";

export const contentHasDefaultPreview = (content?: ContentResponse | ArticlePreviewResponse | PublicContentResponse) =>
    content && content.ogTitle !== null;
